
import React from "react";
import { PartFilter } from "@/data/parts";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { RequirementItemConfig } from "./RequirementItemData";
import { Eye, EyeOff, Slash } from "lucide-react";

interface RequirementItemProps {
  config: RequirementItemConfig;
  isFilterActive: boolean;
  onFilterToggle: (filter: PartFilter) => void;
  isActiveBadge: boolean;
}

const RequirementItem = ({ 
  config, 
  isFilterActive, 
  onFilterToggle,
  isActiveBadge
}: RequirementItemProps) => {
  const { active, label, tooltip, filter, icon, activeColor } = config;
  
  // Dynamically render the icon component from our icon object
  const IconComponent = icon.type;
  
  // Define inactive color - use specific override class
  const inactiveColor = 'text-gray-400 dark:text-gray-600 requirement-inactive';
  
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div 
            className={`flex items-center gap-2 cursor-pointer hover:bg-muted/20 rounded p-1 transition-colors ${isActiveBadge ? "bg-muted/50" : ""}`}
            onClick={() => onFilterToggle(filter)}
          >
            <div className={`flex-shrink-0 relative ${
              isFilterActive 
                ? 'text-gray-500 dark:text-gray-600 requirement-inactive' 
                : active 
                  ? activeColor 
                  : inactiveColor
            }`}>
              <IconComponent {...icon.props} />
              {isFilterActive && (
                <div className="absolute inset-0 flex items-center justify-center text-gray-500 dark:text-gray-600 requirement-inactive">
                  <Slash size={16} className="stroke-[3]" />
                </div>
              )}
            </div>
            <span className={`flex-grow text-xs ${
              isFilterActive 
                ? "text-gray-500 dark:text-gray-600 line-through requirement-inactive" 
                : active 
                  ? activeColor 
                  : inactiveColor
            }`}>
              {label}
            </span>
            <div className={`flex-shrink-0 ${isFilterActive ? "text-gray-500 dark:text-gray-600 requirement-inactive" : "text-muted-foreground"}`}>
              {isFilterActive ? <EyeOff size={14} /> : <Eye size={14} />}
            </div>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>{tooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default RequirementItem;
